import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/hubspot.vue
var o = {
	name: "DtIconHubspot",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--hubspot"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Hubspot",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("rect", {
		x: "2",
		y: "2",
		width: "20",
		height: "20",
		rx: "2",
		fill: "#E77C39"
	}, null, -1), r("path", {
		d: "M6.6 4a1.6 1.6 0 1 0 .853 2.951l4.79 3.61a3.821 3.821 0 0 0-.843 2.399c0 .993.38 1.895.999 2.576l-1.949 1.949a1.28 1.28 0 1 0 .905.905l2.054-2.054h.001a3.84 3.84 0 0 0 5.67-3.376 3.838 3.838 0 0 0-3.2-3.783v-2.15a1.28 1.28 0 1 0-1.418-2.122 1.28 1.28 0 0 0 .138 2.122v2.15a3.812 3.812 0 0 0-1.376.52L8.172 5.891A1.6 1.6 0 0 0 6.6 4Zm8.64 7.04c1.059 0 1.92.861 1.92 1.92s-.861 1.92-1.92 1.92a1.922 1.922 0 0 1-1.92-1.92c0-1.059.861-1.92 1.92-1.92Z",
		fill: "#fff"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=hubspot.js.map